module.exports = __webpack_public_path__ + "img/logo2.b1e352b4.png";